export default "__VITE_ASSET__fUg_tgif__"